import { render, staticRenderFns } from "./ReportBiometricValue.vue?vue&type=template&id=2213b77a"
import script from "./ReportBiometricValue.vue?vue&type=script&lang=js"
export * from "./ReportBiometricValue.vue?vue&type=script&lang=js"
import style0 from "./ReportBiometricValue.vue?vue&type=style&index=0&id=2213b77a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports